import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewCompleteDeliver from "./viewCompleteDeliver";
import CompleteItemsOrderQty from "./completeItemOrderQty";
import CompleteOrderTotal from "./completeOrderTotal";
import { completedViewDetails } from "../../actions/index";
import { bindActionCreators } from "redux";
import Loader from "react-loader";
import { NavLink } from "react-router-dom";
import notification from "../../images/notifications_white.svg";
import api from "../../utility/api/api.js";
class ViewDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (!this.props.orderData) {
      return (
        <div className="">
          <div className="container mw-100">
            {/* <div className="rider-header position-fixed deliver-custom-header">
              <div className="header-left-side">
                <div>
                  <NavLink to="/completed">
                    <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                  </NavLink>
                  <span className="text-white hub-header-title">
                    View Details
                  </span>
                  <img
                    className="float-right pt-1"
                    src={notification}
                    alt="notification"
                  />
                </div>
              </div>
            </div> */}
            <Loader
              loaded={false}
              lines={13}
              length={20}
              width={10}
              radius={30}
              corners={1}
              rotate={0}
              direction={1}
              color="#e51837"
              speed={1}
              trail={60}
              shadow={false}
              hwaccel={false}
              className="spinner"
              zIndex={2e9}
              top="50%"
              left="50%"
              scale={1.0}
              loadedClassName="loadedContent"
            />
          </div>
        </div>
      );
    }

    if (this.props && this.props.orderData && this.props.orderData) {
      return (
        <Fragment>
          <div className=" mw-100">
            {/* <div className="rider-header position-fixed deliver-custom-header">
              <div className="header-left-side">
                <div>
                  <NavLink to="/completed">
                    <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                  </NavLink>
                  <span className="text-white hub-header-title">
                    View Details
                  </span>
                  <img
                    className="float-right pt-1"
                    src={notification}
                    alt="notification"
                  />
                </div>
              </div>
            </div> */}
            <div className="">
              <ViewCompleteDeliver orderdetail={this.props.orderData} />
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  console.log("deliveredViewDetails", state);
  return {
    orderData: state.getcompleteddetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { completedViewDetails: completedViewDetails },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(ViewDetails);



// WEBPACK FOOTER //
// ./src/components/Completed/ViewDetails.js